import * as Actions from "./constants";
import { put, call, takeEvery } from "redux-saga/effects";
import { sendNotificationsData } from "./service";

function* sendNotifications({ postData }) {
  try {
    const { data } = yield call(sendNotificationsData, postData);
    yield put({
      type: Actions.SEND_NOTIFICATION_SUCCESS, 
      payload: data,
    });
  } catch (error) {
    yield put({
      type: Actions.SEND_NOTIFICATION_ERROR, 
      error: error,
    });
  }
}

export default function* SendNotificationsSaga() {
  yield takeEvery(Actions.SEND_NOTIFICATION, sendNotifications);
}
